import { Component,  OnInit, Input, ViewChild} from '@angular/core';
import { ActivatedRoute, Router, ParamMap } from '@angular/router';
import { ApiService } from '../api.service';
import { Observable } from 'rxjs';
import { HttpClient, HttpParams } from '@angular/common/http';
import { User } from '../User';
import { AlertService } from '../alert.service';
import { Inject, Injectable } from '@angular/core';
import { LOCAL_STORAGE, WebStorageService } from 'angular-webstorage-service';
import { months } from 'moment';
import { ModalDirective } from 'angular-bootstrap-md';
import {Location} from '@angular/common';
import { NgxGalleryOptions, NgxGalleryImage, NgxGalleryAnimation } from 'ngx-gallery';

@Component({
  selector: 'app-model-bike',
  templateUrl: './model-bike.component.html',
  styleUrls: ['./model-bike.component.scss']
})
export class ModelBikeComponent implements OnInit {
  @ViewChild('join') join: ModalDirective;
  @ViewChild('alredyJoin') alredyJoin: ModalDirective;
  @ViewChild('JoinBeforeLogin') JoinBeforeLogin: ModalDirective;
  display: 'none';
  btnTextShow: string = 'Read More';
  btnTextHide: string = 'Read Less';
  btnText: string = this.btnTextShow;
  galleryOptions: NgxGalleryOptions[];
  galleryImages: NgxGalleryImage[];
  readContent(): void {
    if (this.btnText === this.btnTextShow) {
      this.btnText = this.btnTextHide;
    }
    else {
      this.btnText = this.btnTextShow;
    }
  }
  subscription_plan_list = [
    { "id": 1, "month":1, "effective_rental": 3500, "wallet":130 },
    { "id": 2, "month":2, "effective_rental": 3350, "wallet":170 },
    { "id": 3, "month":3, "effective_rental": 3330, "wallet":205 },
    { "id": 4, "month":4, "effective_rental": 3295, "wallet":245 },
    { "id": 5, "month":5, "effective_rental": 3255, "wallet":280 },
    { "id": 6, "month":6, "effective_rental": 3220, "wallet":320 },
    { "id": 7, "month":7, "effective_rental": 3180, "wallet":360 },
    { "id": 8, "month":8, "effective_rental": 3140, "wallet":395 },
    { "id": 9, "month":9, "effective_rental": 3105, "wallet":435 },
    { "id": 10, "month":10, "effective_rental": 3065, "wallet":475 },
    { "id": 11, "month":11, "effective_rental": 3025, "wallet":510 },
    { "id": 12, "month":12, "effective_rental": 2990, "wallet":0 }
  ];
  modelDataToShow: Array<any> = [];
  debugData: Boolean = false; // to show and hide the console log messages
  selecetdId: number;
  selectedName: string;  // to get the model data id from url
  selectedMonths:number; // to get the model months from url
  selectedMonthsVal: number = 0; // tp show the selected month in ui from previous page
  joinMsg: string = ""; // to display the join waitlist message
  alreadyJoinMsg: string=""; //to display already joined message
  JoinBeforeLoginMsg: string =""; //to display message before login
  private user: User = new User();
  currentURL ='';
  constructor(private route: ActivatedRoute, private router: Router, private apiService: ApiService, private http: HttpClient,
    @Inject(LOCAL_STORAGE) private storage: WebStorageService, private alertService: AlertService,private location: Location) {
    this.route.paramMap.subscribe(
      params => {
        //console.log(params);
        this.selecetdId = +params.get('id');
        this.selectedName =this.route.snapshot.paramMap.get('name');
        this.selectedMonths = +params.get('months');
        this.checkMonthValid(this.selectedMonths);
        this.currentURL = window.location.href; 
      }
    );

    this.initCustData();
  }

  
  checkMonthValid(moths:number){
    if ((moths == 1) || (moths == 3) || (moths == 6) || (moths == 12)){
      this.selectedMonthsVal = moths;
      this.initModelData(moths);
      //console.log(this.initModelData(6));
    }else{
      this.router.navigate(['/404'])
    }
  }

  goAfterSelectPage(event, id) {
    var paramid = id;
    var monthsId = this.selectedMonthsVal;
    this.router.navigate(['bike-model', paramid, monthsId]);
  }

  //public href: string = "";
  url: string ="";
  public href: string = "";
  ngOnInit() {
   
    decodeURIComponent(this.router.url);
    //this.url = decodeURIComponent(this.router.url);
    this.href = decodeURIComponent(this.router.url);
    //console.log(decodeURIComponent(this.router.url));
   // this.location.go(this.href);

   //gallery
   this.galleryOptions = [
    {
        width: '100%',
        height: '450px',
        thumbnailsColumns: 3,
        imageAnimation: NgxGalleryAnimation.Slide
    },
    // max-width 800
    {
        breakpoint: 800,
        width: '100%',
        height: '600px',
        imagePercent: 80,
        thumbnailsPercent: 20,
        thumbnailsMargin: 20,
        thumbnailMargin: 20
    },
    // max-width 400
    {
        breakpoint: 400,
        preview: false,
        width:'90%',
        height:'300px'
    }
];

this.galleryImages = [
    {
        small: 'assets/images/01-hero-maestro.png',
        medium: 'assets/images/01-hero-maestro.png',
        big: 'assets/images/01-hero-maestro.png'
    },
    {
        small: 'assets/images/03-hero-maestro.png',
        medium: 'assets/images/03-hero-maestro.png',
        big: 'assets/images/03-hero-maestro.png'
    },
    {
        small: 'assets/images/02-hero-maestro.png',
        medium: 'assets/images/02-hero-maestro.png',
        big: 'assets/images/02-hero-maestro.png'
    }
];
  }
  
  initModelData(months: number) {
    this.selectedMonthsVal = months;
    if (this.debugData == true) {
      console.log("Months Selected");
      console.log(this.selectedMonthsVal);
    }

    this.apiService.get('getModelDetailsById?id=' + this.selecetdId)
      .subscribe(dataa => {
        this.modelDataToShow = dataa;
       // console.log(this.modelDataToShow[0].price);
        if(this.modelDataToShow.length != 0){
          this.showRentalSubscriptionPlan(this.modelDataToShow[0].price);
          this.jsonDataArray(months);
          
        }else{
          this.error("Error loading page! Please refresh.");
        }
        
      });

     
  }

  initCustData() {
    if (this.apiService.checkUserLoggedIn() == true) {
        let urrr = this.apiService.cutomerDetails + this.apiService.getFromLocalData('custDD');
        this.http.get(urrr)
            .subscribe(
                data => this.intilizeComponent(data),
                //error => this.showError(error)
            );
    } else {
       // console.log("User Not Logged In. Please login!")
        
    }
}

intilizeComponent(data) {
    this.user = data;
}

  error(message: string) {
    this.alertService.error(message);
  }


  jsonDataArray(months) {
    let monthlyDiscountPercent = [3.64, 4.73, 5.82, 6.91, 8.00, 9.09, 10.18, 11.27, 12.36, 13.45, 14.55 , 0];
    let temp = this.modelDataToShow;
    
      if (months == 1) {
        this.modelDataToShow = temp;
       // console.log(this.modelDataToShow);
      } else if (months == 3) {
        let tempVals = 0;
        for (let i = 0; i < 2; i++) {
          tempVals += Number(((this.modelDataToShow[0].price * monthlyDiscountPercent[i]) / 100).toFixed(2));
          //console.log(tempVals);
        }
        this.modelDataToShow[0].price = this.modelDataToShow[0].price - Number((tempVals / 3).toFixed(0));
        console.log(this.modelDataToShow[0].price);
      } else if (months == 6) {
        let tempVals = 0;
        for (let i = 0; i < 5; i++) {
          tempVals += Number(((this.modelDataToShow[0].price * monthlyDiscountPercent[i]) / 100).toFixed(2));
        }
        this.modelDataToShow[0].price = this.modelDataToShow[0].price - Number((tempVals / 6).toFixed(0));
      } else if (months == 12) {
        let tempVals = 0;
        for (let i = 0; i < 11; i++) {
          tempVals += Number(((this.modelDataToShow[0].price * monthlyDiscountPercent[i]) / 100).toFixed(2));
        }
        this.modelDataToShow[0].price = this.modelDataToShow[0].price - Number((tempVals / 12).toFixed(0));
      }
    
    this.modelDataToShow = temp;
  }

 


  showRentalSubscriptionPlan(BikePrice){
    let monthlyDiscountPercent = [3.64, 4.73, 5.82, 6.91, 8.00, 9.09, 10.18, 11.27, 12.36, 13.45, 14.55, 0];

    for(let i=0; i < monthlyDiscountPercent.length; i++){
      this.subscription_plan_list[i].wallet = Number(((BikePrice * monthlyDiscountPercent[i]) / 100).toFixed(0));
      if (i == 0){
        this.subscription_plan_list[0].effective_rental = BikePrice
      }else{
        this.subscription_plan_list[i].effective_rental = BikePrice - this.subscription_plan_list[i-1].wallet;
       
      }
    }
 
  }
  
  dataToInit: Array<any> = [];
  dataToInit2: Array<any> = [];
  arrangModel(){
      this.dataToInit2 = [];
      for (let i = 0; i < this.dataToInit.length ; i++){
          if ((this.dataToInit[i].available > 0) && (this.dataToInit[i].show >0)){
              this.dataToInit2.push(this.dataToInit[i]);
          }
      }
      for (let i = 0; i < this.dataToInit.length; i++) {
          if (!((this.dataToInit[i].available > 0) && (this.dataToInit[i].show > 0))) {
              this.dataToInit2.push(this.dataToInit[i]);
          }
      }
     
      
      this.dataToInit = this.dataToInit2;
     // console.log("jjj",this.dataToInit.length < 0);
     
  }

  joinWaitlist(event, idModel, nameModel) {
    if (this.apiService.checkUserLoggedIn() == false) {
       // console.log("redirect to the login page if not logged in");
        //this.warn("Please login/signup to join waitlist");
        this.JoinBeforeLoginMsg="Please login/signup to join waitlist";
        this.JoinBeforeLogin.show();
    } else {
        if (this.user.mobile == null || this.user.email == null) {
           // this.warn("please complete your profile");
        } else {
          
            let joinWaitListObjData = {
                "name": this.user.fName,
                "mobile": this.user.mobile,
                "model": nameModel,
                "emailId": this.user.email,
                "modelId": idModel,
                "customerId": this.user.id
            }
            //Posting the data for the joining waitlist
            this.http.post(this.apiService.joinWaitlistUrl, joinWaitListObjData).subscribe((detail: any) => {
                if (detail.status == true) {
                  //console.log(detail.status);
                   // this.success("Waitlist Joined Sucessfully");
                    this.joinMsg="Waitlist Joined Sucessfully";
                    this.join.show();
                } else {
                    //this.info("Waitlist Already Joined");
                    this.alreadyJoinMsg="Waitlist Already Joined";
                    this.alredyJoin.show();
                }
            });
        }
    }
}
} 


// WEBPACK FOOTER //
// C:/unnati/latestWebCode29march/src/app/model-bike/model-bike.component.ts